import React, { useState } from 'react'
import { Badge, Card, Col } from 'react-bootstrap';

export const CEOSalesFunnel = ({ data }) => {
    // 2. Updated Funnel Data with concise tooltip insights:
    const funnelStages = [
        {
            id: "leads",
            stage: "New Leads",
            count: "1,240",
            pct: "100%",
            width: "100%",
            bgGradient: "linear-gradient(135deg, #eef2ff 0%, #e0e7ff 100%)",
            borderColor: "#c7d2fe",
            textColor: "#3730a3",
            insight: "Inbound & Outbound marketing leads collected this period."
        },
        {
            id: "qualified",
            stage: "Qualified Leads",
            count: "620",
            pct: "50.0%",
            width: "85%",
            bgGradient: "linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)",
            borderColor: "#bae6fd",
            textColor: "#0369a1",
            insight: "50% pass BANT criteria (Budget, Authority, Need, Timeline)."
        },
        {
            id: "demos",
            stage: "Demos Scheduled",
            count: "310",
            pct: "25.0%",
            width: "70%",
            bgGradient: "linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%)",
            borderColor: "#a7f3d0",
            textColor: "#047857",
            insight: "Product walkthrough completed with key decision makers."
        },
        {
            id: "proposals",
            stage: "Proposal Sent",
            count: "180",
            pct: "14.5%",
            width: "60%",
            bgGradient: "linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%)",
            borderColor: "#fde68a",
            textColor: "#b45309",
            insight: "Formal commercial quotes and scope of work delivered."
        },
        {
            id: "negotiations",
            stage: "Negotiationsasdfdsafsad",
            count: "85",
            pct: "6.8%",
            width: "50%",
            bgGradient: "linear-gradient(135deg, #faf5f8 0%, #f3e8f0 100%)",
            borderColor: "#e8d8e3",
            textColor: "#7a3a5e",
            insight: "Final contract review, security compliance, and pricing alignment."
        },
    ]

    const [hoveredStage, setHoveredStage] = useState(null);
    const [tooltipPos, setTooltipPos] = useState({ top: 0, left: 0 });

    const handleMouseEnter = (item, e) => {
        setHoveredStage(item);
        const rect = e.currentTarget.getBoundingClientRect();
        const parentRect = e.currentTarget.parentElement.getBoundingClientRect();

        // Calculate position relative to the parent funnel container
        setTooltipPos({
            top: rect.top - parentRect.top - 8, // Position slightly above the layer
            left: rect.left - parentRect.left + rect.width / 2 // Center horizontally over layer
        });
    };

    const handleMouseLeave = () => {
        setHoveredStage(null);
    };
    return (
        <Col lg={4}>
            <Card className=" shadow-sm rounded-3 h-100 pt-0 px-0 " style={{ backgroundColor: "#ffffff", border: "1px solid #e3e3e3", width: "100%" }}>
                <Card.Body className="px-3 pt-3 pb-2 ">
                    <div className="d-flex align-items-center justify-content-between ">
                        <div>
                            <span className="d-block mb-0 pb-0" style={{ fontWeight: 500, fontSize: '16px', }}>Sales Conversion Funnel</span>
                            <span className="text-muted d-block" style={{ fontSize: "11px" }}>Hover over any stage to view details</span>
                        </div>
                        <Badge
                            className="rounded-pill px-3 py-2 fw-semibold border"
                            style={{ backgroundColor: "#faf5f8", color: 'white', borderColor: "#e8d8e3", fontSize: "11.5px" }}
                        >
                            Win Rate: 3.8%
                        </Badge>
                    </div>

                    <hr style={{ height: '0.1rem' }} />

                    <div className="position-relative d-flex flex-column align-items-center gap-2" style={{ width: "100%" }}>
                        {funnelStages.map((item, idx) => {
                            const isHovered = hoveredStage?.id === item.id;
                            const isAnyHovered = hoveredStage !== null;

                            return (
                                <div
                                    key={item.id}
                                    onMouseEnter={(e) => handleMouseEnter(item, e)}
                                    onMouseLeave={handleMouseLeave}
                                    className="position-relative d-flex align-items-center justify-content-between gap-2 px-4 rounded-3"
                                    style={{
                                        width: item.width,
                                        height: "60px",
                                        background: item.bgGradient,
                                        border: `1.5px solid ${item.borderColor}`,
                                        boxShadow: isHovered
                                            ? "0 10px 20px rgba(0,0,0,0.08), 0 2px 6px rgba(0,0,0,0.04)"
                                            : "0 2px 4px rgba(0,0,0,0.02)",
                                        clipPath: idx < funnelStages.length - 1
                                            ? "polygon(0 0, 100% 0, 94% 100%, 7% 100%)"
                                            : "polygon(0 0, 100% 0, 92% 100%, 7% 100%)",
                                        transform: isHovered ? "scale(1.03) translateY(-2px)" : "scale(1)",
                                        opacity: isHovered ? 1 : isAnyHovered ? 0.4 : 1,
                                        filter: isAnyHovered && !isHovered ? "grayscale(20%)" : "none",
                                        transition: "transform 0.2s ease, opacity 0.2s ease, filter 0.2s ease",
                                        cursor: "pointer",
                                        zIndex: isHovered ? 10 : 1
                                    }}
                                >
                                    <span className="fw-bold ps-2"
                                        style={{
                                            color: item.textColor,
                                            fontSize: "12.5px",
                                            width: "250px",
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            direction: 'ltr',
                                            textAlign: 'left',
                                        }}>
                                        {item.stage}
                                    </span>

                                    <div className="pe-2 text-end d-flex align-items-center gap-2">
                                        <span className="fw-bold" style={{ color: item.textColor, fontSize: "13px" }}>
                                            {item.count}
                                        </span>
                                        <span
                                            className="badge rounded-pill border fw-semibold"
                                            style={{
                                                backgroundColor: "rgba(255,255,255,0.85)",
                                                color: item.textColor,
                                                borderColor: item.borderColor,
                                                fontSize: "10px"
                                            }}
                                        >
                                            {item.pct}
                                        </span>
                                    </div>
                                </div>
                            );
                        })}

                        {hoveredStage && (
                            <div
                                className="position-absolute rounded-3 p-3 shadow-lg border text-start pe-none"
                                style={{
                                    top: `${tooltipPos.top}px`,
                                    left: `${tooltipPos.left}px`,
                                    transform: "translate(-50%, -100%)",
                                    backgroundColor: "rgba(255, 255, 255, 0.95)",
                                    backdropFilter: "blur(8px)",
                                    borderColor: hoveredStage.borderColor,
                                    zIndex: 100,
                                    minWidth: "200px",
                                    maxWidth: "260px"
                                }}
                            >
                                <div className="d-flex align-items-center justify-content-between mb-1">
                                    <span className="fw-bold" style={{ color: hoveredStage.textColor, fontSize: "12px" }}>
                                        {hoveredStage.stage}
                                    </span>
                                    <span className="badge rounded-pill bg-dark text-white" style={{ fontSize: "9px" }}>
                                        {hoveredStage.pct}
                                    </span>
                                </div>
                                <p className="mb-0 text-muted" style={{ fontSize: "10.5px", lineHeight: "1.4" }}>
                                    {hoveredStage.insight}
                                </p>
                            </div>
                        )}
                    </div>

                </Card.Body>
            </Card>
        </Col>
    )
}
